import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { State, Action, Getter, Mutation } from 'vuex-class';
import ShortcutPanel from '@/components/ShortcutPanel.vue';
import InformationPanel from '@/components/InformationPanel.vue';
import SnackbarUtils from '@/../bower_components/teknisavuecomponents/assets/utils/SnackbarUtils';
import { ActionPermissao, ControleAcessoController, ModuloPermissao } from '@/assets/ts/controller/ControleAcessoController';
import User from '@/assets/ts/interfaces/User';
import Util from '@/../bower_components/teknisavuecomponents/assets/utils/Util';

@Component({
  name: 'Dashboard',
  components: {
    ShortcutPanel,
    InformationPanel,
  },
})
class Dashboard extends Vue {
  // #region [ DATA ]
  private viewName = 'Dashboard';
  private viewTitle = 'Portal do Gestor';

  private notification = 'mdi-bell';

  private triggerReloadInfo = 0;

  private infoPanelIsLoading = false;
  // #endregion

  // #region [ STORE ]
  @Getter('user')
  private user: User;

  @Getter('estruturaGerencialAtual')
  private estruturaGerencialAtual: any;

  @Getter('periodoDemonstrativoAtual')
  private periodoDemonstrativoAtual: any;

  @Mutation('changeCurrentView')
  private changeCurrentView: any;

  @Mutation('updateNotifications')
  private updateNotifications: (messages: string[]) => void;
  // #endregion

  // #region [ COMPUTED ]
  private get nrEstrutura(): string {
    const nrEstrut = this.estruturaGerencialAtual ?
      this.estruturaGerencialAtual.NRESTRUTURAM :
      '';

    return nrEstrut;
  }

  private get nrPeriodo(): string {
    const nrPeri = this.periodoDemonstrativoAtual ?
      this.periodoDemonstrativoAtual.NRPERIODOAPURACAO :
      '';

    return nrPeri;
  }

  private get filtersAreSelected(): boolean {
    const selected =
      this.nrEstrutura !== '' &&
      this.nrPeriodo   !== '';

    return selected;
  }

  private get buttonIsDisabled(): boolean {
    const disabled =
      this.infoPanelIsLoading ||
      !this.filtersAreSelected;

    return disabled;
  }

  get temAcessoDashboard() {
    return ControleAcessoController.temPermissao(ModuloPermissao.MODULO_DASHBOARD, ActionPermissao.IDVISUALIZAR);
  }

  private get userName(): string {
    const firstName = this.user.name.split(' ')[0];

    const capitalizedName = firstName ?
      Util.initCap(firstName) :
      'colaborador';

    return capitalizedName;
  }

  // #endregion

  // #region [ LIFECYCLE ]
  private created() {
    this.changeCurrentView(this.viewTitle);
  }

  private mounted() {
    this.reloadInfoPanel();
  }
  // #endregion

  // #region [ WATCHERS ]
  @Watch('periodoDemonstrativoAtual')
  private periodoDemonstrativoAtualOnChange() {
    this.reloadInfoPanel();
  }

  @Watch('estruturaGerencialAtual')
  private estruturaGerencialAtualOnChange() {
    this.reloadInfoPanel();
  }
  // #endregion

  // #region [ METHODS ]
  private toggleNotification() {
    if (this.notification === 'mdi-bell') {
      this.notification = 'mdi-bell-off';
    } else {
      this.notification = 'mdi-bell';
    }
  }

  private reloadButtonOnClick() {
    this.reloadInfoPanel();
  }


  private infoPanelAfterReload(cardsRows: any) {
    this.infoPanelIsLoading = false;
    this.setNotifications(cardsRows);
  }

  private reloadInfoPanel() {
    if (this.filtersAreSelected) {
      this.triggerReloadInfo++;
      this.infoPanelIsLoading = true;
    }
  }

  private setNotifications(cardsRows: any) {
    const notifications: string[] = [];

    cardsRows.feriasCard.forEach((row: any) => {
      const nmVinculo = row.NMVINCULOM;
      const message = `As férias de ${nmVinculo} vencerão dentro de 3 meses.`;
      notifications.push(message);
    });

    cardsRows.contratosCard.forEach((row: any) => {
      const nmVinculo = row.NMVINCULOM;
      const message = `O contrato de ${nmVinculo} vencerá dentro de 90 dias.`;
      notifications.push(message);
    });

    cardsRows.licencasCard.forEach((row: any) => {
      const nmVinculo = row.NMVINCULOM;
      const message = `A licença materinidade de ${nmVinculo} vencerá dentro de 10 dias.`;
      notifications.push(message);
    });

    this.updateNotifications(notifications);
  }
  // #endregion
}

export default Dashboard;
